import RadioInput from './RadioInput';

export default RadioInput;
